import { render, staticRenderFns } from "./TestGames.vue?vue&type=template&id=382d64fc&scoped=true&"
import script from "./TestGames.vue?vue&type=script&lang=js&"
export * from "./TestGames.vue?vue&type=script&lang=js&"
import style0 from "./TestGames.vue?vue&type=style&index=0&id=382d64fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382d64fc",
  null
  
)

export default component.exports